module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-runtime/core-js/object/create.js
// module id = 852
// module chunks = 0